var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.45H1a1 1 0 0 0 0 2h1.19V16.8a6.9 6.9 0 0 0 6.89 6.89h5.83a6.9 6.9 0 0 0 6.89-6.89V5.45H23a1 1 0 0 0 0-2ZM19.81 16.8a4.9 4.9 0 0 1-4.89 4.89H9.09a4.9 4.9 0 0 1-4.9-4.89V5.45h15.62ZM9.06 2h5.89a1 1 0 0 0 0-2H9.06a1 1 0 0 0 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 19a1 1 0 0 0 1-1V8.91a1 1 0 0 0-2 0V18a1 1 0 0 0 1 1ZM14.94 19a1 1 0 0 0 1-1V8.91a1 1 0 1 0-2 0V18a1 1 0 0 0 1 1Z"
  })));
};
export default SvgTrash;